import api from "../../../utilidades/interceptor";
import axios from "axios";

const urlApi = process.env.REACT_APP_API_KEY

export const getDescuentosColaboradores = async () => {
    try {
        const result = await api.get(`${urlApi}/talentoHumano/getDescuentosColaborador`);
        return result.data;
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}

export const getDescuentosOperadores = async () => {
    try {
        const result = await api.get(`${urlApi}/talentoHumano/getDescuentosChofer`);
        return result.data;
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}

export const  getDescuentoOpById = async (id) => {

    try {
        const result = await api.get(`${urlApi}/talentoHumano/getDescuentoOperadorById?id=${id}`);
        return result.data;
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}

export const  getDescuentoColById = async (id) => {

    try {
        const result = await api.get(`${urlApi}/talentoHumano/getDescuentoColaboradorById?id=${id}`);
        return result.data;
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}

export const getColaboratorsList = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getActiveColabList`);

        const mappedData = response.data.map(colaborator => ({
            label: colaborator.NOMBRE,
            value: colaborator.ID
        }));

        return mappedData;
    } catch (error) {
    }
}


export const getGrupos = async () => {
    try {
        const response = await api.get(`${urlApi}/talentoHumano/getGrupos`);

        const mappedData = response.data.map(grupo => ({
            label: `${grupo.SIGLAS} - ${grupo.DESCRIPCION}`,
            value: grupo.ID
        }));

        return mappedData;
    } catch (error) {
        throw new Error(error);
    }
}

export const getDescuentosHerramientas = async (colaborador) => {

    try {
        const result = await api.get(`${urlApi}/talentoHumano/getDescuentosHerramienta`);

        if (colaborador) {

            const filtered = result.data.filter(item => item.COLABORADOR === true);
            return filtered.map(herramienta => ({
                label: herramienta.HERRAMIENTA,
                value: herramienta.ID,
            }));

        } else {

            const filtered = result.data.filter(item => item.OPERADOR === true);

            return filtered.map(herramienta => ({
                label: herramienta.HERRAMIENTA,
                value: herramienta.ID,
            }));

        }

    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}

export const updateDescuentoColaborador = async (data) => {
    try {
        const result = await api.patch(`${urlApi}/talentoHumano/updateDescuentoColaborador`, {
            dataReq: data,
        });
        return result.data;
    } catch (error) {
        console.log("error", error);
    }
}

export const updateDescuentoOperador = async (data) => {
    try {
        const result = await api.patch(`${urlApi}/talentoHumano/updateDescuentoOperador`, {
            dataReq: data,
        });
        return result.data;
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}

export const getAllColabNames = async () => {

    try {
        const result = await api.get(`${urlApi}/talentoHumano/getAllColabs`);

        return result.data.map(colab => ({
            label: colab.NOMBRE,
            value: colab.ID,
        }));
    }catch (e) {
        throw new Error(e);
    }

}

export const getAllChoferNames = async () => {

    try {
        const result = await api.get(`${urlApi}/talentoHumano/getAllChoferNames`);
        return result.data.map(chofer => ({
            label: chofer.NOMBRE,
            value: chofer.ID,
        }));
    }catch (e) {
        throw new Error(e);
    }

}

export const getUnidades = async () => {
    try {
        const res = await api.get(`${urlApi}/operaciones/getUnits`);
        // ajusta según la forma real: res.data o res.data.data
        return res?.data.map(unit => ({
            label: unit.name,
            value: unit.code,
        })) ?? [];
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}


export const insertDescuento = async (data) => {
    try {
        const result = await api.post(`${urlApi}/talentoHumano/insertDescuento`, {
            dataReq: data,
        });

        return result.data;
    } catch (error) {
        throw new Error(`Error ${error}`);
    }
}
const line = (label, value) => {
    if (value === null || value === undefined || value === '') return '';
    // para números 0, sí muestra
    if (typeof value === 'number' && Number.isFinite(value)) return `<p>${label}: <strong>${value}</strong></p>`;
    const v = String(value).trim();
    return v === '' ? '' : `<p>${label}: <strong>${v}</strong></p>`;
};
const formatUTCDate = (isoDateString) => {
    if (!isoDateString) return '';

    try {
        const date = new Date(isoDateString);

        return date.toLocaleDateString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            timeZone: 'UTC'
        });
    } catch (e) {
        console.warn("Fecha inválida:", isoDateString);
        // Fallback: si la fecha es inválida, muestra solo la parte de la fecha
        return isoDateString.split('T')[0];
    }
};
// Utilidad: tabla HTML de detalle (siempre se muestra)
const buildDetailHtml = (detalle = {}) => `
  <h2 style="color:#004080;">Detalle de registro</h2>
 
  ${line('Fecha', formatUTCDate(detalle?.FECHA))}
  ${line('Usuario', detalle?.USUARIO)}
  ${line('Departamento', detalle?.DEPARTAMENTO)}
  ${line('Herramienta', detalle?.HERRAMIENTA)}
  ${line('Unidad', detalle?.UNIDAD)}
  ${line('Colaborador', detalle?.COLABORADOR)}
  ${line('Monto', detalle?.MONTO)}
  ${line('No. Descuentos', detalle?.NO_DESCUENTOS)}
  ${line('Monto Descuento', detalle?.MONTO_DESCUENTO)}
  ${line('Periodo Inicio', detalle?.PERIODO_INICIO)}
  ${line('Estatus', detalle?.ESTATUS)}
`;

// Utilidad: genera tabla de cambios comparando objetos (solo si hay diferencias)
const buildChangeLogHtml = (before = {}, after = {}) => {
    const isEmpty = (v) => v === null || v === undefined || v === '' || (typeof v === 'string' && v.trim() === '');
    const normalize = (v) => Array.isArray(v) ? v.join(', ') : (typeof v === 'object' && v !== null ? JSON.stringify(v) : v);

    const allowedKeys = [
        'ID','FECHA','USUARIO','DEPARTAMENTO','ID_DESCUENTO_HERRAM','ID_UNIDAD','ID_CHOFER','ID_COLABORADOR',
        'MONTO','NO_DESCUENTOS','MONTO_DESCUENTO','PERIODO_INICIO','ESTATUS','MOTIVO','ID_REEMBOLSO'
    ];

    const keys = Array.from(new Set([...Object.keys(before || {}), ...Object.keys(after || {})]))
        .filter(k => allowedKeys.includes(k));

    const rows = keys.map((key) => {
        const oldVal = normalize(before?.[key]);
        const newVal = normalize(after?.[key]);

        // no mostrar si ambos vacíos
        if (isEmpty(oldVal) && isEmpty(newVal)) return null;
        // no mostrar si iguales (como string)
        if (`${oldVal}` === `${newVal}`) return null;

        return `
      <tr>
        <td style="padding:8px;border:1px solid #ddd;">${key}</td>
        <td style="padding:8px;border:1px solid #ddd;color:#a00;">${isEmpty(oldVal) ? '-' : oldVal}</td>
        <td style="padding:8px;border:1px solid #ddd;color:#070;">${isEmpty(newVal) ? '-' : newVal}</td>
      </tr>
    `;
    }).filter(Boolean);

    if (!rows.length) return '';
    return `
    <h3 style="color:#004080;margin-top:24px;">Bitácora de cambios</h3>
    <table width="100%" style="border-collapse:collapse;margin-top:8px;">
      <thead>
        <tr style="background:#f5f7fb;">
          <th style="padding:8px;border:1px solid #ddd;text-align:left;">Campo modificado</th>
          <th style="padding:8px;border:1px solid #ddd;text-align:left;">Valor antiguo</th>
          <th style="padding:8px;border:1px solid #ddd;text-align:left;">Valor nuevo</th>
        </tr>
      </thead>
      <tbody>${rows.join('')}</tbody>
    </table>
  `;
};

export const buildWhatsappMessageDescuento = (params) => {
    const newline = "\r\n"; // Salto de línea para WhatsApp

    // --- 1. Helper: Formateador de moneda ---
    // Devuelve null si el valor no es un número válido (incl. null/undefined)
    const formatCurrency = (amount) => {
        const num = parseFloat(amount);
        if (isNaN(num)) {
            return null; // No es un número válido, no mostrar
        }
        try {
            return num.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN'
            });
        } catch (e) {
            return String(amount); // Fallback por si algo falla
        }
    };

    // --- 2. Determinar el Destinatario ---
    let targetName = '';
    let targetIntro = '';
    if (params.OPERADOR) {
        // Obtener solo el primer nombre para el saludo
        targetName = params.OPERADOR.split(' ')[0] || 'Operador';
        targetIntro = `*Operador:* 👤 ${params.OPERADOR}`;
    } else if (params.COLABORADOR) {
        targetName = params.COLABORADOR.split(' ')[0] || 'Colaborador';
        targetIntro = `*Colaborador:* 👤 ${params.COLABORADOR}`;
    } else {
        targetName = 'Colaborador(a)';
    }

    // --- 3. Construir el mensaje por partes ---
    // Usamos un array para poder filtrar líneas vacías
    const messageParts = [];

    messageParts.push(`📢 *NUEVO DESCUENTO VÍA NÓMINA* 📢`);
    messageParts.push(`Hola ${targetName}, se ha registrado un nuevo descuento a tu nombre.`);


    if (params.ID) {
        messageParts.push(`*Folio:* #️⃣ ${params.ID}`);
    }
    if (targetIntro) {
        messageParts.push(targetIntro);
    }


    if (params.MOTIVO) {
        messageParts.push(`🧾 *Motivo del Descuento:*`);
        messageParts.push(`_${params.MOTIVO || 'Sin motivo especificado'}_`);
    }



    const detallesLines = [];
    const montoTotal = formatCurrency(params.MONTO);
    const montoPago = formatCurrency(params.MONTO_DESCUENTO);


    if(params.HERRAMIENTA){
        detallesLines.push(`• 🔧 *Herramienta:* ${params.HERRAMIENTA}`);
    }

    if (params.UNIDAD) {
        detallesLines.push(`• 🚍 *Unidad:* ${params.UNIDAD}`);
    }
    if (montoTotal) {
        detallesLines.push(`• 💵 *Monto Total:* ${montoTotal}`);
    }

    if (params.NO_DESCUENTOS) {
        detallesLines.push(`• 🔢 *Número de descuentos:* ${params.NO_DESCUENTOS}`);
    }
    if (montoPago) {
        detallesLines.push(`• 💸 *Monto de descuento:* ${montoPago}`);
    }

    if (params.PERIODO_INICIO) {
        detallesLines.push(`• 🗓️ *Inicia:* ${params.PERIODO_INICIO}`);
    }

    if (detallesLines.length > 0) {
        messageParts.push(`📋 *Detalles del Descuento:*`);

        messageParts.push(detallesLines.join(newline));
    }

    messageParts.push(`---`);
    messageParts.push(`ℹ️ Este es un mensaje informativo. Para cualquier aclaración, favor de contactar a Talento Humano.`);

    return messageParts.filter(Boolean).join(newline + newline);
};

export const notifyNuevoDescuento = async (params, correos) => {
    const year = new Date().getUTCFullYear();

    let emailTitle;
    let emailSubject;
    let introLine = '';

    if (params.OPERADOR) {
        // Caso para Operador
        emailTitle = 'Descuento a Operador';
        emailSubject = `Nuevo Descuento: Operador ${params.OPERADOR}`;
        introLine = `<p>Le informamos que se ha capturado un nuevo descuento con el folio <strong>#${params.ID}</strong> al operador <strong>${params.OPERADOR}</strong>.</p>`;
    } else  {
        // Caso para Colaborador
        emailTitle = 'Descuento a Colaborador';
        emailSubject = `Nuevo Descuento: Colaborador ${params.COLABORADOR}`;
        introLine = `<p>Le informamos que se ha capturado un nuevo descuento con el folio <strong>#${params.ID}</strong> al colaborador <strong>${params.COLABORADOR}</strong>.</p>`;
    }


    const htmlBody = `
            <!DOCTYPE html>
            <html lang="es">
            <head>
            <meta charset="UTF-8">
            <title>${emailTitle}</title> </head>
            <body style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 20px; color: #333;">
            <table width="100%" style="max-width: 600px; margin: auto; background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                <tr style="background-color: #004080; color: white;">
                <td style="padding: 15px; display: flex; align-items: center;">
                   
                </td>
                </tr>
                <tr>
                <td style="padding: 30px;">
                    <h2 style="color: #004080;">Nuevo descuento vía nómina</h2>
                    
                    ${introLine} 
                    ${ params.MOTIVO ?
                    `<p><strong>Por el motivo: </strong></p>
                    <blockquote style="border-left: 4px solid #004080; margin: 10px 0; padding-left: 10px; color: #555;">
                    ${params.MOTIVO}
                    </blockquote>`
        : ''
    }
                    
                    ${buildDetailHtml(params)}
           
                    <hr style="margin: 30px 0;">
                    <p style="font-size: 0.9em; color: #888;">
                    Por favor, no responda a este correo. Este mensaje ha sido generado automáticamente por el sistema Suma en Línea para informarle de creación y actualización de descuentos.
                    </p>
               
                    <p style="margin-top: 30px;">Atentamente,<br><strong>Departamento de Innovación y Desarrollo</strong><br>Suma te lleva</p>
                </td>
                </tr>
                <tr>
                <td style="background-color: #f0f0f0; text-align: center; padding: 15px; font-size: 0.8em; color: #777;">
                    &copy; ${year} Suma te lleva. Todos los derechos reservados.
                </td>
                </tr>
            </table>
            </body>
            </html>
            `;


    const paramsCorreo = {
        to: correos,
        subject: emailSubject,
        text: '',
        html: htmlBody // Cuerpo de HTML
    };

    try {
        await axios.post('https://notificaciones.sumaenlinea.mx/mail/sendEmail', paramsCorreo);
    } catch (erro) {
        console.log("erro", erro);
    }
};


export const notifyBitacoraDescuento = async (antes, despues, correos, detalle = {}) => {
    const year = new Date().getUTCFullYear();


    const detailHtml = buildDetailHtml({
        ...detalle,
        ID: detalle?.ID ?? despues?.ID ?? antes?.ID
    });


    const changeLog = buildChangeLogHtml(antes, despues);

    const changesByHtml = changeLog ? `
        <p style="margin-top: 15px; font-style: italic; color: #555; font-size: 0.9em;">
            Cambios por: <strong>${despues?.editedBy ?? 'N/A'}</strong>
        </p>
    ` : '';


    const html = `
        <!DOCTYPE html>
        <html lang="es">
        <head>
            <meta charset="UTF-8">
            <title>Descuento editado</title>
        </head>
        <body style="font-family: Arial, sans-serif; background-color: #f9f9f9; padding: 20px; color: #333;">
            <table width="100%" style="max-width: 600px; margin: auto; background-color: #ffffff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                <tr style="background-color: #004080; color: white;">
                    <td style="padding: 15px;"></td>
                </tr>
                <tr>
                    <td style="padding: 30px;">
                        ${detailHtml}
                        ${changeLog || ''}
                        ${changesByHtml}
                        <hr style="margin: 30px 0;">
                        <p style="font-size: 0.9em; color: #888;">
                            Por favor, no responda a este correo. Este mensaje ha sido generado automáticamente por el sistema Suma en Línea para informarle de cambios en descuentos.
                        </p>
                        <p style="margin-top: 30px;">Atentamente,<br><strong>Departamento de Innovación y Desarrollo</strong><br>Suma te lleva</p>
                    </td>
                </tr>
                <tr>
                    <td style="background-color: #f0f0f0; text-align: center; padding: 15px; font-size: 0.8em; color: #777;">
                        &copy; ${year} Suma te lleva. Todos los derechos reservados.
                    </td>
                </tr>
            </table>
        </body>
        </html>
    `;

    const paramsCorreo = { to: correos, subject: 'Bitácora de cambios - Descuento editado', text: '', html };

    try {
        await axios.post('https://notificaciones.sumaenlinea.mx/mail/sendEmail', paramsCorreo);
    } catch (error) {
        console.log("error", error);
    }
};

export const sendWhatsapp = async (params) => {

    try {

        const message = buildWhatsappMessageDescuento(params.details);
        const phones = params.phones

        const payload = {
            dataReq: {
                mensaje: message,
                telefonos: phones
            }
        };
         await api.post(
            `${urlApi}/talentoHumano/sendDiscountMessage`,
            payload
        );
    } catch (error) {
        console.error('Error sending WhatsApp message:', error);
    }
}

export const getContactInformation= async (params) => {

    try {

        const body = { ids: params };
        return (await api.post(
            `${urlApi}/talentoHumano/getContactInfoById`,
            body
        )).data;
    }catch (error) {
        console.error('Error sending WhatsApp message:', error);
    }
}


